import { render, staticRenderFns } from "./PurchaseCredits.vue?vue&type=template&id=5c998ee0&"
import script from "./PurchaseCredits.vue?vue&type=script&lang=js&"
export * from "./PurchaseCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports